var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.dynamicButtonComponent,{tag:"component",attrs:{"color":_vm.errors.length > 0 ? 'error' : 'primary'},on:{"click":function($event){return _vm.$emit('click:openDialog')}},scopedSlots:_vm._u([{key:"tooltip",fn:function(){return [_vm._t("tooltip")]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }